KXL.module('Components', function(Components, KXL, Backbone, Marionette, $, _) {
	Components.Layout = Marionette.Layout.extend();
});
